/**
 * purit-shower-quiz-widget.js
 * Widget quiz Filtro Doccia Purit — zero dipendenze, funziona in qualsiasi pagina HTML.
 *
 * Utilizzo:
 *   <div id="purit-shower-quiz"></div>
 *   <script src="purit-shower-quiz-widget.js"></script>
 *   <script>PuritShowerQuiz.init('#purit-shower-quiz');</script>
 *
 * Opzioni:
 *   PuritShowerQuiz.init('#purit-shower-quiz', {
 *     onComplete: function(result) { console.log(result); }
 *   });
 */
(function () {
  'use strict';

  /* ─── DATI CAP ─────────────────────────────────────────────────────────── */

  var CAP_DATA = {
    '10100': { city: 'Torino', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '15100': { city: 'Alessandria', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '14100': { city: 'Asti', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '12100': { city: 'Cuneo', region: 'Piemonte', hardness: 'Morbida', hf: 1.12 },
    '28100': { city: 'Novara', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '13100': { city: 'Vercelli', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '13900': { city: 'Biella', region: 'Piemonte', hardness: 'Morbida', hf: 1.10 },
    '28921': { city: 'Verbania', region: 'Piemonte', hardness: 'Morbida', hf: 1.15 },
    '11100': { city: 'Aosta', region: "Valle d'Aosta", hardness: 'Morbida', hf: 1.20 },
    '16100': { city: 'Genova', region: 'Liguria', hardness: 'Morbida', hf: 1.18 },
    '17100': { city: 'Savona', region: 'Liguria', hardness: 'Morbida', hf: 1.15 },
    '18100': { city: 'Imperia', region: 'Liguria', hardness: 'Moderata', hf: 1.05 },
    '19100': { city: 'La Spezia', region: 'Liguria', hardness: 'Morbida', hf: 1.12 },
    '20100': { city: 'Milano', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '24100': { city: 'Bergamo', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '25100': { city: 'Brescia', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '22100': { city: 'Como', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '26100': { city: 'Cremona', region: 'Lombardia', hardness: 'Dura', hf: 0.82 },
    '23100': { city: 'Lecco', region: 'Lombardia', hardness: 'Morbida', hf: 1.08 },
    '26900': { city: 'Lodi', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '46100': { city: 'Mantova', region: 'Lombardia', hardness: 'Dura', hf: 0.80 },
    '20900': { city: 'Monza', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '27100': { city: 'Pavia', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '23900': { city: 'Sondrio', region: 'Lombardia', hardness: 'Morbida', hf: 1.15 },
    '21100': { city: 'Varese', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '39100': { city: 'Bolzano', region: 'Alto Adige', hardness: 'Morbida', hf: 1.22 },
    '38100': { city: 'Trento', region: 'Trentino', hardness: 'Morbida', hf: 1.18 },
    '30100': { city: 'Venezia', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '36100': { city: 'Vicenza', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '37100': { city: 'Verona', region: 'Veneto', hardness: 'Dura', hf: 0.80 },
    '35100': { city: 'Padova', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '31100': { city: 'Treviso', region: 'Veneto', hardness: 'Moderata', hf: 0.95 },
    '32100': { city: 'Belluno', region: 'Veneto', hardness: 'Morbida', hf: 1.15 },
    '45100': { city: 'Rovigo', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '34100': { city: 'Trieste', region: 'Friuli V.G.', hardness: 'Molto dura', hf: 0.72 },
    '33100': { city: 'Udine', region: 'Friuli V.G.', hardness: 'Moderata', hf: 1.00 },
    '34170': { city: 'Gorizia', region: 'Friuli V.G.', hardness: 'Dura', hf: 0.85 },
    '33170': { city: 'Pordenone', region: 'Friuli V.G.', hardness: 'Moderata', hf: 0.98 },
    '40100': { city: 'Bologna', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '44100': { city: 'Ferrara', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '47100': { city: 'Forlì', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.98 },
    '42100': { city: 'Reggio Emilia', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '41100': { city: 'Modena', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '43100': { city: 'Parma', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '29100': { city: 'Piacenza', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.95 },
    '48100': { city: 'Ravenna', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '47900': { city: 'Rimini', region: 'Emilia-Romagna', hardness: 'Dura', hf: 0.85 },
    '50100': { city: 'Firenze', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '52100': { city: 'Arezzo', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '59100': { city: 'Prato', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '51100': { city: 'Pistoia', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '56100': { city: 'Pisa', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '57100': { city: 'Livorno', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '53100': { city: 'Siena', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '58100': { city: 'Grosseto', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '55100': { city: 'Lucca', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '54100': { city: 'Massa', region: 'Toscana', hardness: 'Morbida', hf: 1.10 },
    '06100': { city: 'Perugia', region: 'Umbria', hardness: 'Moderata', hf: 1.00 },
    '05100': { city: 'Terni', region: 'Umbria', hardness: 'Molto dura', hf: 0.75 },
    '60100': { city: 'Ancona', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63100': { city: 'Ascoli Piceno', region: 'Marche', hardness: 'Moderata', hf: 1.00 },
    '62100': { city: 'Macerata', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '61121': { city: 'Pesaro', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63900': { city: 'Fermo', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '00100': { city: 'Roma', region: 'Lazio', hardness: 'Molto dura', hf: 0.70 },
    '04100': { city: 'Latina', region: 'Lazio', hardness: 'Dura', hf: 0.82 },
    '03100': { city: 'Frosinone', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '01100': { city: 'Viterbo', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '02100': { city: 'Rieti', region: 'Lazio', hardness: 'Molto dura', hf: 0.72 },
    '67100': { city: "L'Aquila", region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '66100': { city: 'Chieti', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '65100': { city: 'Pescara', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '64100': { city: 'Teramo', region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '86100': { city: 'Campobasso', region: 'Molise', hardness: 'Dura', hf: 0.85 },
    '86170': { city: 'Isernia', region: 'Molise', hardness: 'Moderata', hf: 0.95 },
    '70100': { city: 'Bari', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '71100': { city: 'Foggia', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '72100': { city: 'Brindisi', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '73100': { city: 'Lecce', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '74100': { city: 'Taranto', region: 'Puglia', hardness: 'Molto dura', hf: 0.70 },
    '75100': { city: 'Matera', region: 'Basilicata', hardness: 'Dura', hf: 0.82 },
    '85100': { city: 'Potenza', region: 'Basilicata', hardness: 'Moderata', hf: 1.00 },
    '87100': { city: 'Cosenza', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '88100': { city: 'Catanzaro', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '89100': { city: 'Reggio Calabria', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '80100': { city: 'Napoli', region: 'Campania', hardness: 'Molto dura', hf: 0.70 },
    '81100': { city: 'Caserta', region: 'Campania', hardness: 'Molto dura', hf: 0.72 },
    '82100': { city: 'Benevento', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '83100': { city: 'Avellino', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '84100': { city: 'Salerno', region: 'Campania', hardness: 'Dura', hf: 0.85 },
    '90100': { city: 'Palermo', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '91100': { city: 'Trapani', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '92100': { city: 'Agrigento', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '93100': { city: 'Caltanissetta', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '94100': { city: 'Enna', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '95100': { city: 'Catania', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '96100': { city: 'Siracusa', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '97100': { city: 'Ragusa', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '98100': { city: 'Messina', region: 'Sicilia', hardness: 'Dura', hf: 0.85 },
    '07100': { city: 'Sassari', region: 'Sardegna', hardness: 'Moderata', hf: 1.00 },
    '09100': { city: 'Cagliari', region: 'Sardegna', hardness: 'Dura', hf: 0.85 },
    '08100': { city: 'Nuoro', region: 'Sardegna', hardness: 'Morbida', hf: 1.10 },
    '09170': { city: 'Oristano', region: 'Sardegna', hardness: 'Moderata', hf: 1.00 },
  };

  var PREFIX_FALLBACK = {
    '10': { city: 'Torino area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '11': { city: "Valle d'Aosta area", region: "Valle d'Aosta", hardness: 'Morbida', hf: 1.18 },
    '12': { city: 'Cuneo area', region: 'Piemonte', hardness: 'Morbida', hf: 1.10 },
    '13': { city: 'Vercelli/Biella area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '14': { city: 'Asti area', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '15': { city: 'Alessandria area', region: 'Piemonte', hardness: 'Moderata', hf: 0.98 },
    '16': { city: 'Genova area', region: 'Liguria', hardness: 'Morbida', hf: 1.15 },
    '17': { city: 'Savona area', region: 'Liguria', hardness: 'Morbida', hf: 1.12 },
    '18': { city: 'Imperia area', region: 'Liguria', hardness: 'Moderata', hf: 1.05 },
    '19': { city: 'La Spezia area', region: 'Liguria', hardness: 'Morbida', hf: 1.10 },
    '20': { city: 'Milano area', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '21': { city: 'Varese area', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '22': { city: 'Como area', region: 'Lombardia', hardness: 'Morbida', hf: 1.08 },
    '23': { city: 'Sondrio/Lecco area', region: 'Lombardia', hardness: 'Morbida', hf: 1.10 },
    '24': { city: 'Bergamo area', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '25': { city: 'Brescia area', region: 'Lombardia', hardness: 'Moderata', hf: 0.95 },
    '26': { city: 'Cremona/Lodi area', region: 'Lombardia', hardness: 'Dura', hf: 0.85 },
    '27': { city: 'Pavia area', region: 'Lombardia', hardness: 'Moderata', hf: 0.92 },
    '28': { city: 'Novara area', region: 'Piemonte', hardness: 'Moderata', hf: 1.00 },
    '29': { city: 'Piacenza area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.95 },
    '30': { city: 'Venezia area', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '31': { city: 'Treviso area', region: 'Veneto', hardness: 'Moderata', hf: 0.95 },
    '32': { city: 'Belluno area', region: 'Veneto', hardness: 'Morbida', hf: 1.15 },
    '33': { city: 'Udine/Pordenone area', region: 'Friuli V.G.', hardness: 'Moderata', hf: 0.98 },
    '34': { city: 'Trieste/Gorizia area', region: 'Friuli V.G.', hardness: 'Molto dura', hf: 0.72 },
    '35': { city: 'Padova area', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '36': { city: 'Vicenza area', region: 'Veneto', hardness: 'Dura', hf: 0.82 },
    '37': { city: 'Verona area', region: 'Veneto', hardness: 'Dura', hf: 0.80 },
    '38': { city: 'Trento area', region: 'Trentino', hardness: 'Morbida', hf: 1.18 },
    '39': { city: 'Bolzano area', region: 'Alto Adige', hardness: 'Morbida', hf: 1.22 },
    '40': { city: 'Bologna area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '41': { city: 'Modena area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '42': { city: 'Reggio Emilia area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '43': { city: 'Parma area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 1.00 },
    '44': { city: 'Ferrara area', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '45': { city: 'Rovigo area', region: 'Veneto', hardness: 'Molto dura', hf: 0.72 },
    '46': { city: 'Mantova area', region: 'Lombardia', hardness: 'Dura', hf: 0.80 },
    '47': { city: 'Forlì/Rimini area', region: 'Emilia-Romagna', hardness: 'Moderata', hf: 0.98 },
    '48': { city: 'Ravenna area', region: 'Emilia-Romagna', hardness: 'Molto dura', hf: 0.72 },
    '50': { city: 'Firenze area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '51': { city: 'Pistoia area', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '52': { city: 'Arezzo area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '53': { city: 'Siena area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '54': { city: 'Massa area', region: 'Toscana', hardness: 'Morbida', hf: 1.08 },
    '55': { city: 'Lucca area', region: 'Toscana', hardness: 'Moderata', hf: 1.05 },
    '56': { city: 'Pisa area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '57': { city: 'Livorno area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '58': { city: 'Grosseto area', region: 'Toscana', hardness: 'Moderata', hf: 1.00 },
    '59': { city: 'Prato area', region: 'Toscana', hardness: 'Moderata', hf: 1.02 },
    '60': { city: 'Ancona area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '61': { city: 'Pesaro area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '62': { city: 'Macerata area', region: 'Marche', hardness: 'Moderata', hf: 0.98 },
    '63': { city: 'Ascoli/Fermo area', region: 'Marche', hardness: 'Moderata', hf: 1.00 },
    '64': { city: 'Teramo area', region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '65': { city: 'Pescara area', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '66': { city: 'Chieti area', region: 'Abruzzo', hardness: 'Dura', hf: 0.85 },
    '67': { city: "L'Aquila area", region: 'Abruzzo', hardness: 'Moderata', hf: 1.00 },
    '68': { city: 'Isernia area', region: 'Molise', hardness: 'Moderata', hf: 0.95 },
    '70': { city: 'Bari area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '71': { city: 'Foggia area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '72': { city: 'Brindisi area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '73': { city: 'Lecce area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '74': { city: 'Taranto area', region: 'Puglia', hardness: 'Molto dura', hf: 0.70 },
    '75': { city: 'Matera area', region: 'Basilicata', hardness: 'Dura', hf: 0.82 },
    '76': { city: 'Barletta area', region: 'Puglia', hardness: 'Molto dura', hf: 0.72 },
    '80': { city: 'Napoli area', region: 'Campania', hardness: 'Molto dura', hf: 0.70 },
    '81': { city: 'Caserta area', region: 'Campania', hardness: 'Molto dura', hf: 0.72 },
    '82': { city: 'Benevento area', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '83': { city: 'Avellino area', region: 'Campania', hardness: 'Dura', hf: 0.82 },
    '84': { city: 'Salerno area', region: 'Campania', hardness: 'Dura', hf: 0.85 },
    '85': { city: 'Potenza area', region: 'Basilicata', hardness: 'Moderata', hf: 1.00 },
    '86': { city: 'Campobasso area', region: 'Molise', hardness: 'Dura', hf: 0.85 },
    '87': { city: 'Cosenza area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '88': { city: 'Catanzaro area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '89': { city: 'Reggio Calabria area', region: 'Calabria', hardness: 'Moderata', hf: 1.00 },
    '90': { city: 'Palermo area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '91': { city: 'Trapani area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '92': { city: 'Agrigento area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '93': { city: 'Caltanissetta area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '94': { city: 'Enna area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '95': { city: 'Catania area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '96': { city: 'Siracusa area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.68 },
    '97': { city: 'Ragusa area', region: 'Sicilia', hardness: 'Molto dura', hf: 0.70 },
    '98': { city: 'Messina area', region: 'Sicilia', hardness: 'Dura', hf: 0.85 },
  };

  /* ─── LOGICA DI CALCOLO ─────────────────────────────────────────────────── */

  var SHOWERS_FACTOR  = { '1': 1.20, '2-3': 1.05, '4-5': 0.82, '6+': 0.62 };
  var DURATION_FACTOR = { '<5': 1.10, '5-10': 1.02, '10+': 0.87 };
  var BUILDING_FACTOR = { '<10': 1.08, '10-30': 1.03, '30-50': 0.90, '50+': 0.78 };
  var MAX_DAYS = 180;
  var MIN_DAYS = 60;
  var BOOST    = 0.88;

  // Fattori manutenzione (stessa logica del quiz rubinetto)
  var MAINTENANCE_FACTOR = {
    'full':     { '<2': 1.10, '2-5': 1.05, '5-10': 1.00 },
    'ordinary': { '<2': 1.02, '2-5': 1.00, '5-10': 0.98 },
  };

  function getCapData(cap) {
    var clean = (cap || '').replace(/\D/g, '');
    while (clean.length < 5) clean = '0' + clean;
    return CAP_DATA[clean] || PREFIX_FALLBACK[clean.slice(0, 2)] || { city: 'Italia', region: '', hardness: 'Moderata', hf: 1.00 };
  }

  function getProblemFactor(problems) {
    if (!problems || !problems.length || problems.indexOf('none') !== -1) return 1.00;
    var count = problems.filter(function (p) { return p !== 'none'; }).length;
    if (count >= 3) return 0.73;
    if (count === 2) return 0.86;
    return 0.94;
  }

  function applyMaintenanceFactor(buildingAge, workType, workYears) {
    if (buildingAge !== '30-50' && buildingAge !== '50+') return null;
    if (!workType || workType === 'none') return BUILDING_FACTOR[buildingAge];
    var table = MAINTENANCE_FACTOR[workType];
    if (!table || !workYears) return BUILDING_FACTOR[buildingAge];
    return table[workYears] || BUILDING_FACTOR[buildingAge];
  }

  function calculate(state) {
    var capInfo        = getCapData(state.cap);
    var showersFactor  = SHOWERS_FACTOR[state.showers]      || 1.00;
    var durFactor      = DURATION_FACTOR[state.duration]     || 1.00;
    var baseBf         = BUILDING_FACTOR[state.buildingAge]  || 1.00;
    var maintFactor    = applyMaintenanceFactor(state.buildingAge, state.maintenanceWork, state.maintenanceYears);
    var buildFactor    = maintFactor !== null ? maintFactor : baseBf;
    var probFactor     = getProblemFactor(state.problems);
    var combined       = capInfo.hf * showersFactor * durFactor * buildFactor * probFactor * BOOST;
    var days          = Math.round(Math.min(MAX_DAYS, Math.max(MIN_DAYS, MAX_DAYS * combined)));
    var months        = parseFloat((days / 30).toFixed(1));
    return { capInfo: capInfo, days: days, months: months };
  }

  /* ─── OPZIONI QUIZ ──────────────────────────────────────────────────────── */

  var SHOWERS_OPTIONS = [
    { key: '1',   label: '1 doccia al giorno' },
    { key: '2-3', label: '2-3 docce al giorno' },
    { key: '4-5', label: '4-5 docce al giorno' },
    { key: '6+',  label: '6 o piu docce al giorno' },
  ];
  var DURATION_OPTIONS = [
    { key: '<5',   label: 'Meno di 5 minuti' },
    { key: '5-10', label: '5-10 minuti' },
    { key: '10+',  label: 'Piu di 10 minuti' },
  ];
  var BUILDING_OPTIONS = [
    { key: '<10',   label: 'Meno di 10 anni' },
    { key: '10-30', label: '10-30 anni' },
    { key: '30-50', label: '30-50 anni' },
    { key: '50+',   label: 'Oltre 50 anni' },
  ];
  var WORK_TYPE_OPTIONS = [
    { key: 'none',     label: 'Nessun lavoro recente' },
    { key: 'ordinary', label: 'Manutenzione ordinaria (pulizia, riparazioni parziali)' },
    { key: 'full',     label: 'Sostituzione tubature (rifacimento impianto completo)' },
  ];
  var WORK_YEARS_OPTIONS = [
    { key: '<2',   label: 'Meno di 2 anni fa' },
    { key: '2-5',  label: '2-5 anni fa' },
    { key: '5-10', label: '5-10 anni fa' },
  ];
  var PROBLEM_OPTIONS = [
    { key: 'limescale', label: 'Calcare sul soffione' },
    { key: 'skin',      label: 'Residui sulla pelle' },
    { key: 'hair',      label: 'Capelli secchi e sfibrati' },
    { key: 'chlorine',  label: 'Odore di cloro' },
    { key: 'none',      label: 'Nessun problema' },
  ];

  /* ─── CSS (stile allineato al quiz rubinetto) ──────────────────────────── */

  var CSS = [
    '.psq-wrap{font-family:"Manrope",-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;max-width:560px;margin:0 auto;padding:32px 24px;background:#fff;border-radius:20px;box-sizing:border-box;border:1px solid #D0E2F4}',
    '.psq-wrap *{box-sizing:border-box}',
    /* Step dots */
    '.psq-steps-nav{display:flex;align-items:center;justify-content:center;gap:0;margin-bottom:28px}',
    '.psq-step-dot{width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:13px;font-weight:700;border:2px solid #D0E2F4;background:#fff;color:#7A94B0;transition:all .3s;flex-shrink:0}',
    '.psq-step-dot.active{border-color:#639922;background:#639922;color:#fff;box-shadow:0 0 0 4px rgba(99,153,34,0.15)}',
    '.psq-step-dot.done{border-color:#639922;background:#EDF5E0;color:#639922}',
    '.psq-step-line{width:48px;height:2px;background:#D0E2F4;transition:background .3s}',
    '.psq-step-line.done{background:#639922}',
    /* Domanda */
    '.psq-question{font-size:22px;font-weight:700;color:#0B2545;margin:0 0 8px}',
    '.psq-hint{font-size:14px;color:#7A94B0;margin:0 0 20px}',
    '.psq-section-label{font-size:15px;font-weight:600;color:#0B2545;margin:20px 0 10px}',
    /* CAP */
    '.psq-cap-input{display:block;width:100%;padding:16px;font-size:24px;font-family:"Manrope",monospace;letter-spacing:8px;text-align:center;border:1.5px solid #D0E2F4;border-radius:12px;background:#fff;color:#0B2545;outline:none;margin-bottom:16px}',
    '.psq-cap-input:focus{border-color:#639922}',
    '.psq-cap-card{display:flex;align-items:center;gap:12px;background:#f7fcff;border:1px solid #D0E2F4;border-radius:12px;padding:14px;margin-bottom:4px}',
    '.psq-cap-icon{font-size:20px}',
    '.psq-cap-city{font-size:15px;font-weight:700;color:#0B2545;margin:0 0 2px}',
    '.psq-cap-hardness{font-size:13px;color:#7A94B0;margin:0}',
    '.psq-cap-hardness b{color:#1E4D8C}',
    /* Opzioni */
    '.psq-options{display:flex;flex-direction:column;gap:10px}',
    '.psq-option{display:flex;align-items:center;gap:12px;background:#fff;border:1.5px solid #D0E2F4;border-radius:12px;padding:14px 16px;cursor:pointer;transition:border-color .15s,background .15s}',
    '.psq-option:hover{border-color:#639922;background:#FFFFFF}',
    '.psq-option.selected{border-color:#639922;background:#EDF5E0}',
    '.psq-radio{width:22px;height:22px;border-radius:50%;border:2px solid #D0E2F4;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color .15s}',
    '.psq-option.selected .psq-radio{border-color:#639922}',
    '.psq-radio-dot{width:10px;height:10px;border-radius:50%;background:#639922;display:none}',
    '.psq-option.selected .psq-radio-dot{display:block}',
    '.psq-checkbox{width:22px;height:22px;border-radius:6px;border:2px solid #D0E2F4;display:flex;align-items:center;justify-content:center;flex-shrink:0;transition:border-color .15s,background .15s;font-size:14px;color:#fff}',
    '.psq-option.selected .psq-checkbox{border-color:#639922;background:#639922}',
    '.psq-option-label{font-size:15px;color:#0B2545;line-height:1.4}',
    '.psq-option.selected .psq-option-label{font-weight:600;color:#0B2545}',
    /* Bottoni */
    '.psq-buttons{display:flex;align-items:center;gap:12px;margin-top:32px}',
    '.psq-back{display:flex;align-items:center;gap:6px;padding:14px 16px;font-size:15px;font-weight:600;color:#3A5070;background:none;border:2px solid #D0E2F4;cursor:pointer;border-radius:12px;transition:all .15s}',
    '.psq-back:hover{background:#f7fcff;border-color:#1E4D8C}',
    '.psq-next{flex:1;padding:16px;font-size:16px;font-weight:700;color:#fff;background:#639922;border:none;border-radius:12px;cursor:pointer;transition:opacity .15s,background .15s;box-shadow:0 4px 20px rgba(99,153,34,0.25)}',
    '.psq-next:hover:not(:disabled){background:#4E7A1B}',
    '.psq-next:disabled{opacity:.4;cursor:not-allowed}',
    /* Risultati */
    '.psq-results-title{font-size:22px;font-weight:800;color:#0B2545;margin:0 0 4px}',
    '.psq-results-sub{font-size:14px;color:#7A94B0;margin:0 0 24px}',
    '.psq-water-info{background:#f7fcff;border:1px solid #D0E2F4;border-radius:10px;padding:12px 14px;margin-bottom:20px;font-size:13px;color:#0B2545}',
    '.psq-water-info b{color:#1E4D8C}',
    '.psq-result-card{background:#f7fcff;border:1px solid #D0E2F4;border-radius:14px;padding:20px;margin-bottom:14px}',
    '.psq-result-card-header{display:flex;align-items:center;gap:12px;margin-bottom:16px}',
    '.psq-result-icon{width:44px;height:44px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:22px;flex-shrink:0}',
    '.psq-result-name{font-size:16px;font-weight:700;color:#0B2545;margin:0 0 2px}',
    '.psq-result-hardness{font-size:13px;color:#7A94B0;margin:0}',
    '.psq-result-days{font-size:52px;font-weight:800;color:#0B2545;line-height:1;margin:0 0 4px;font-variant-numeric:tabular-nums}',
    '.psq-result-days-label{font-size:14px;color:#7A94B0;margin:0 0 14px}',
    '.psq-result-bar-bg{height:8px;background:#D0E2F4;border-radius:4px;overflow:hidden;margin-bottom:8px}',
    '.psq-result-bar-fill{height:100%;border-radius:4px}',
    '.psq-result-months{font-size:13px;color:#7A94B0}',
    '.psq-restart{width:100%;margin-top:8px;padding:14px;font-size:15px;font-weight:600;color:#3A5070;background:#fff;border:2px solid #D0E2F4;border-radius:12px;cursor:pointer;transition:all .15s}',
    '.psq-restart:hover{background:#f7fcff;border-color:#1E4D8C}',
  ].join('');

  /* ─── STATO DEL QUIZ ────────────────────────────────────────────────────── */

  function createState() {
    return {
      stepIndex: 0,
      showers: '',
      duration: '',
      cap: '',
      capInfo: null,
      buildingAge: '',
      maintenanceWork: '',
      maintenanceYears: '',
      problems: [],
    };
  }

  // Step dinamici: manutenzione appare solo per edifici vecchi
  function getSteps(state) {
    var needsMaint = state.buildingAge === '30-50' || state.buildingAge === '50+';
    var steps = ['showers', 'duration', 'cap', 'buildingAge'];
    if (needsMaint) steps.push('maintenance');
    steps.push('problems');
    return steps;
  }

  function canContinue(state) {
    var steps = getSteps(state);
    var step = steps[state.stepIndex];
    if (step === 'showers')     return state.showers !== '';
    if (step === 'duration')    return state.duration !== '';
    if (step === 'cap')         return state.cap.length === 5;
    if (step === 'buildingAge') return state.buildingAge !== '';
    if (step === 'maintenance') return state.maintenanceWork !== '' && (state.maintenanceWork === 'none' || state.maintenanceYears !== '');
    if (step === 'problems')    return state.problems.length > 0;
    return false;
  }

  /* ─── RENDER ────────────────────────────────────────────────────────────── */

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'className') el.className = attrs[k];
        else if (k === 'style') el.style.cssText = attrs[k];
        else el.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      if (typeof children === 'string') el.innerHTML = children;
      else if (Array.isArray(children)) children.forEach(function (c) { if (c) el.appendChild(c); });
      else el.appendChild(children);
    }
    return el;
  }

  function renderRadio(options, value, onChange) {
    var wrap = h('div', { className: 'psq-options' });
    options.forEach(function (opt) {
      var selected = value === opt.key;
      var row = h('div', { className: 'psq-option' + (selected ? ' selected' : '') });
      row.appendChild(h('div', { className: 'psq-radio' }, h('div', { className: 'psq-radio-dot' })));
      row.appendChild(h('span', { className: 'psq-option-label' }, opt.label));
      row.addEventListener('click', function () { onChange(opt.key); });
      wrap.appendChild(row);
    });
    return wrap;
  }

  function renderCheckbox(options, selected, onToggle) {
    var wrap = h('div', { className: 'psq-options' });
    options.forEach(function (opt) {
      var checked = selected.indexOf(opt.key) !== -1;
      var row = h('div', { className: 'psq-option' + (checked ? ' selected' : '') });
      row.appendChild(h('div', { className: 'psq-checkbox' }, checked ? '&#10003;' : ''));
      row.appendChild(h('span', { className: 'psq-option-label' }, opt.label));
      row.addEventListener('click', function () { onToggle(opt.key); });
      wrap.appendChild(row);
    });
    return wrap;
  }

  function renderStep(state, container, onUpdate) {
    var steps = getSteps(state);
    var step = steps[state.stepIndex];
    var frag = document.createDocumentFragment();

    if (step === 'showers') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Quante docce vengono fatte in totale al giorno in casa?'));
      frag.appendChild(renderRadio(SHOWERS_OPTIONS, state.showers, function (v) { state.showers = v; onUpdate(); }));
    }

    if (step === 'duration') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Quanto dura ogni doccia?'));
      frag.appendChild(renderRadio(DURATION_OPTIONS, state.duration, function (v) { state.duration = v; onUpdate(); }));
    }

    if (step === 'cap') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Qual è il tuo CAP?'));
      frag.appendChild(h('p', { className: 'psq-hint' }, 'Ci serve per stimare la durezza dell\'acqua nella tua zona'));
      var input = h('input', { className: 'psq-cap-input', type: 'text', maxlength: '5', placeholder: 'Es. 20100', value: state.cap });
      input.addEventListener('input', function () {
        var v = this.value.replace(/\D/g, '').slice(0, 5);
        this.value = v;
        state.cap = v;
        state.capInfo = v.length === 5 ? getCapData(v) : null;
        onUpdate();
      });
      frag.appendChild(input);
      if (state.capInfo) {
        var card = h('div', { className: 'psq-cap-card' });
        card.appendChild(h('span', { className: 'psq-cap-icon' }, '&#128703;'));
        var info = h('div');
        info.appendChild(h('p', { className: 'psq-cap-city' }, state.capInfo.city + (state.capInfo.region ? ', ' + state.capInfo.region : '')));
        info.appendChild(h('p', { className: 'psq-cap-hardness' }, 'Durezza acqua: <b>' + state.capInfo.hardness + '</b>'));
        card.appendChild(info);
        frag.appendChild(card);
      }
    }

    if (step === 'buildingAge') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Quanti anni ha il tuo edificio?'));
      frag.appendChild(renderRadio(BUILDING_OPTIONS, state.buildingAge, function (v) { state.buildingAge = v; onUpdate(); }));
    }

    if (step === 'maintenance') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Lavori di manutenzione'));
      frag.appendChild(h('p', { className: 'psq-hint' }, 'Sono stati effettuati lavori alla rete idrica dell\'edificio negli ultimi 10 anni?'));
      frag.appendChild(h('p', { className: 'psq-section-label' }, 'Tipo di lavori'));
      frag.appendChild(renderRadio(WORK_TYPE_OPTIONS, state.maintenanceWork, function (v) { state.maintenanceWork = v; state.maintenanceYears = ''; onUpdate(); }));
      if (state.maintenanceWork && state.maintenanceWork !== 'none') {
        frag.appendChild(h('p', { className: 'psq-section-label' }, 'Quando?'));
        frag.appendChild(renderRadio(WORK_YEARS_OPTIONS, state.maintenanceYears, function (v) { state.maintenanceYears = v; onUpdate(); }));
      }
    }

    if (step === 'problems') {
      frag.appendChild(h('p', { className: 'psq-question' }, 'Hai riscontrato problemi con la doccia?'));
      frag.appendChild(h('p', { className: 'psq-hint' }, 'Puoi selezionare piu opzioni'));
      frag.appendChild(renderCheckbox(PROBLEM_OPTIONS, state.problems, function (key) {
        if (key === 'none') {
          state.problems = ['none'];
        } else {
          var without = state.problems.filter(function (p) { return p !== 'none'; });
          var idx = without.indexOf(key);
          state.problems = idx !== -1 ? without.filter(function (p) { return p !== key; }) : without.concat([key]);
        }
        onUpdate();
      }));
    }

    container.appendChild(frag);
  }

  function renderResults(state, container, onRestart, onComplete) {
    var result = calculate(state);
    if (typeof onComplete === 'function') onComplete(result);

    var pct = Math.round((result.days / MAX_DAYS) * 100);

    container.appendChild(h('p', { className: 'psq-results-title' }, 'Ecco la stima per il tuo filtro'));
    container.appendChild(h('p', { className: 'psq-results-sub' }, 'Basata sulla durezza dell\'acqua a ' + result.capInfo.city + ' e sul tuo utilizzo'));

    var waterInfo = h('div', { className: 'psq-water-info' });
    waterInfo.innerHTML = '&#128703; Acqua di <b>' + result.capInfo.city + '</b>: durezza <b style="color:#1E4D8C">' + result.capInfo.hardness + '</b>';
    container.appendChild(waterInfo);

    var card = h('div', { className: 'psq-result-card' });

    var header = h('div', { className: 'psq-result-card-header' });
    var icon = h('div', { className: 'psq-result-icon', style: 'background:#e6f1fb' }, '&#128703;');
    var nameWrap = h('div');
    nameWrap.appendChild(h('p', { className: 'psq-result-name' }, 'Filtro Doccia'));
    nameWrap.appendChild(h('p', { className: 'psq-result-hardness' }, 'Durata stimata'));
    header.appendChild(icon);
    header.appendChild(nameWrap);
    card.appendChild(header);

    card.appendChild(h('p', { className: 'psq-result-days' }, String(result.days)));
    card.appendChild(h('p', { className: 'psq-result-days-label' }, 'giorni stimati'));

    var barBg = h('div', { className: 'psq-result-bar-bg' });
    var fill = h('div', { className: 'psq-result-bar-fill', style: 'width:' + pct + '%;background:#639922' });
    barBg.appendChild(fill);
    card.appendChild(barBg);
    card.appendChild(h('p', { className: 'psq-result-months' }, 'Circa ' + result.months + ' mesi'));

    container.appendChild(card);
    // Nessun pulsante dopo il risultato: mostra solo la durata stimata.
  }

  /* ─── WIDGET PRINCIPALE ────────────────────────────────────────────────── */

  function render(container, state, opts) {
    // Salva posizione cursore per il CAP input
    var prevCapCursor = null;
    var prevCapInput = container.querySelector('.psq-cap-input');
    if (prevCapInput && document.activeElement === prevCapInput) {
      prevCapCursor = prevCapInput.selectionStart;
    }

    container.innerHTML = '';
    var steps = getSteps(state);
    var total = steps.length;
    var isLast = state.stepIndex === total - 1;

    // Step dots (pallini numerati)
    var stepsNav = h('div', { className: 'psq-steps-nav' });
    for (var i = 0; i < total; i++) {
      var dotClass = 'psq-step-dot';
      if (i === state.stepIndex) dotClass += ' active';
      else if (i < state.stepIndex) dotClass += ' done';
      stepsNav.appendChild(h('div', { className: dotClass }, String(i + 1)));
      if (i < total - 1) {
        var lineClass = 'psq-step-line';
        if (i < state.stepIndex) lineClass += ' done';
        stepsNav.appendChild(h('div', { className: lineClass }));
      }
    }
    container.appendChild(stepsNav);

    // Contenuto step
    var stepWrap = h('div');
    renderStep(state, stepWrap, function () { render(container, state, opts); });
    container.appendChild(stepWrap);

    // Ripristina focus sul CAP input dopo re-render
    if (steps[state.stepIndex] === 'cap') {
      var newCapInput = container.querySelector('.psq-cap-input');
      if (newCapInput && prevCapCursor !== null) {
        newCapInput.focus();
        newCapInput.setSelectionRange(prevCapCursor, prevCapCursor);
      }
    }

    // Bottoni
    var buttons = h('div', { className: 'psq-buttons' });
    if (state.stepIndex > 0) {
      var backBtn = h('button', { className: 'psq-back' }, '&#8592; Indietro');
      backBtn.addEventListener('click', function () { state.stepIndex--; render(container, state, opts); });
      buttons.appendChild(backBtn);
    }
    var ok = canContinue(state);
    var nextBtn = h('button', { className: 'psq-next' }, isLast ? 'Calcola risultati' : 'Continua &#8594;');
    if (!ok) nextBtn.setAttribute('disabled', 'disabled');
    nextBtn.addEventListener('click', function () {
      if (!ok) return;
      if (isLast) {
        container.innerHTML = '';
        renderResults(state, container, function () {
          render(container, createState(), opts);
        }, opts && opts.onComplete);
      } else {
        state.stepIndex++;
        render(container, state, opts);
      }
    });
    buttons.appendChild(nextBtn);
    container.appendChild(buttons);
  }

  /* ─── CSS INJECTION ─────────────────────────────────────────────────────── */

  function injectCSS() {
    if (document.getElementById('purit-shower-quiz-css')) return;
    var style = document.createElement('style');
    style.id = 'purit-shower-quiz-css';
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  /* ─── API PUBBLICA ──────────────────────────────────────────────────────── */

  function init(selector, opts) {
    injectCSS();
    var container = typeof selector === 'string' ? document.querySelector(selector) : selector;
    if (!container) { console.error('PuritShowerQuiz: elemento non trovato:', selector); return; }
    container.className = (container.className ? container.className + ' ' : '') + 'psq-wrap';
    render(container, createState(), opts || {});
  }

  /* ─── EXPORT ────────────────────────────────────────────────────────────── */

  if (typeof window !== 'undefined') {
    window.PuritShowerQuiz = { init: init };
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { init: init };
  }

})();
